<template>
<div>
    <Nav></Nav>
      <div class="w mains">
    <main>
      <div class="cus"></div>
      <div class="main_header">
      <transition>
        <img src="../assets/img/guanyu.png" ref="mainshe" alt="">
          <!-- <a href="javascript:;" >关于我们</a> -->
      </transition>
      </div>

      <div class="main">Hundred平台是一家开发动漫运营社区的广告传媒公司；隶属于上海致源广告传媒有限公司，随着网络游戏的迅速发展， 中国网络游戏市场规模逐渐扩大， 游戏收入有望超越美国排名全球第一。
单一媒体已无法满足游戏大市场的需求， 因而产生了如今的Hundred广告投放平台；
平台结合了如今市场上游戏投放主流媒体的资源以及我们慢慢挖掘的初步商业化媒体的资源融入平台的SSP， 长期累积下来的DMP数据包更能帮助广告主达到理想效果.团队来自各大游戏厂商以及渠道代理优秀优化人员， 公司原有漫画设计人员能更好地提供素材设计思路以及修改原有素材。 我们拥有专业的技术团队，拥有广阔的媒体资源，拥有资深的优化师。Hundred希望给手游带来独特的价值， 移动互联网将因广告而更精彩！
</div>
      <div class="main_footer">
        <ul>
          <li v-for="(item,index) in reagrs" :key="index">
            <img v-lazy="item.img" alt="">
            <span>{{item.name}}</span>
            <p>{{item.desc}}</p>
          </li>

        </ul>
      </div>

    </main>
  </div>
  <Footer></Footer>
</div>
</template>

<script>
import img from '../assets/image/about.png'
import img1 from '../assets/image/about3.png'
import img2 from '../assets/image/about2.png'
import Footer from '../components/Footer'
import Nav from '../components/Nav'

export default {
  components: {
    Footer,
    Nav
  },
  data () {
    return {

      reagrs: [{ name: '我们是谁', desc: 'Hundred平台隶属于上海致源广告传媒有限公司，基于自主原创动漫和文学。', img: img2 }, { name: '我们做什么', desc: '平台结合了如今市场上游戏投放主流媒体的资源以及我们慢慢挖掘的初步商业化媒体的资源融入平台的SSP。', img: img1 }, { img: img, name: '我们的优势', desc: '拥有王牌优化师，具有标砖高效的流程，三方DMP,跨平台数据，精准投放，获取更有效用户' }]
    }
  }
}
</script>

<style lang="scss" scoped>
  .w {
      main {
        position: relative;
        height: 778px;
        // .cus {
        //   width: 100%;
        //   border-bottom: 1px solid#EBECED;
        //  position: absolute;
        //  top: 60px;
        // }
        margin-top: 100px;
         span {
          display: block;
          text-align: center;
        }
        .main_header {
        cursor: pointer;
        text-align: center;

        height: 28px;
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: bold;

        margin-bottom: 66px;
        a {
          color: #3F3F40;
          &:hover {
            border-bottom: 5px solid #046AFF;

          }
        }

        }
        .main {
          text-align: center;
        height: 208px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #323333;
        line-height: 32px;
        }
        .main_footer {

          text-align: center ;
          margin-top: 33px;
          ul {
            display: flex;
            li {
              margin-right: 25px;

              img {

                width: 375px;
                height: 240px;
               transition: 1s ease-in-out;
               -webkit-transform-style: preserve-3d;
                transform-style: preserve-3d;
               &:hover {
               -webkit-transform: rotateY(0.5turn);
               transform: rotateY(0.5turn);
                opacity: 0.6;

               }
              }

              span {

                width: 90px;
                height: 21px;
                font-size: 18px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #323333;
                line-height: 32px;
                margin-left: 110px;
               margin: 20px auto
              }
              p {
                margin-top: 20px;
                width: 341px;
                height: 42px;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #656566;
                line-height: 26px;
                  margin: 0px auto
              }
            }
          }
        }
      }
    }
</style>
